module.exports = __webpack_public_path__ + "img/img (8).028a001a.png";